var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-tenants': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),_c('div',{staticClass:"top-title text-center"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.data.title}})],1),_vm._v(" "),_c('AtomsCommonAtomTenants',{attrs:{"tenants":_vm.data.tenants}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }